import React, { FC, useCallback } from 'react';
import Drawer from '@Components/Common/Drawer/Drawer';
import Toggle from '@Components/Common/Toggle/Toggle';
import { ProjectLocationColumn } from '../../Locations.types';
import { ColumnOption } from '@Types/columns';

interface ColumnsDrawerProps {
    onComplete: () => void;
    onColumnToggle: (field: string, isActive: boolean) => void;
    columnOptions: ColumnOption<ProjectLocationColumn>[];
    columns: ProjectLocationColumn[];
}

const ColumnsDrawer: FC<ColumnsDrawerProps> = ({ onComplete, onColumnToggle, columnOptions, columns }) => {
    const columnIsActive = useCallback(
        (column: ColumnOption<ProjectLocationColumn>): boolean => {
            return columns.some((m) => m.field === column.value.field);
        },
        [columns]
    );

    const handleFormChange = useCallback(
        (name: string, value: boolean) => {
            onColumnToggle(name, value);
        },
        [onColumnToggle]
    );

    return (
        <Drawer isWide={false} title='Columns' cancelText='Close' onCancelClick={onComplete}>
            {columnOptions.map((column) => (
                <div key={column.value.field}>
                    <Toggle name={column.value.field} text={column.label} checked={columnIsActive(column)} onChange={handleFormChange} />
                </div>
            ))}
        </Drawer>
    );
};

export default ColumnsDrawer;
